function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-235.04 -20.292)"
}, /*#__PURE__*/React.createElement("path", {
  id: "path69759",
  stroke: "#000",
  strokeWidth: 12,
  d: "m292.21 22.527c-0.84 0.023-1.69 0.252-2.46 0.701l-49.88 28.797c-2.49 1.438-3.34 4.598-1.9 7.089l16.99 29.432c1.44 2.492 4.61 3.337 7.1 1.898l26.06-15.048v109.98c0 2.87 2.33 5.19 5.2 5.19h96.29c2.88 0 5.19-2.32 5.19-5.19v-110.14l26.34 15.204c2.49 1.439 5.65 0.594 7.09-1.898l16.99-29.432c1.44-2.491 0.59-5.651-1.9-7.089l-49.87-28.797c-1.01-0.584-2.14-0.791-3.21-0.664-0.21-0.025-0.41-0.037-0.63-0.037h-27.58c-0.41 3.273-9.41 5.893-20.44 5.893-11.02 0-20.02-2.62-20.43-5.893h-27.84c-0.16 0-0.33 0.014-0.49 0.03-0.21-0.02-0.41-0.035-0.62-0.03z"
}));

function SvgShirt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 213.12 172.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShirt);
export default __webpack_public_path__ + "static/media/shirt.add3c748.svg";
export { ForwardRef as ReactComponent };